import { render } from "./ContentGroup.vue?vue&type=template&id=ac6c64a8&ts=true"
import script from "./ContentGroup.vue?vue&type=script&lang=ts"
export * from "./ContentGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__